import { call, put, takeEvery } from "redux-saga/effects";
import AXIOS_INSTANCE from "../../utils/USOBConfig";
import axios from "axios";
import USOBApiRequest from "../../utils/ApiUrls";
import { getAuthUserDetails } from "../../utils/Helpers";
import {
  analyticsByMonthLoading,
  submitAnalyticsByMonthActionDispatcher,
  submitAnalyticsByMonthErrorDispatcher,
  SUBMIT_ANALYTICS_BY_MONTH_ACTION_REQUESTED,
} from "./Action"; // Path should come here

const postAnalyticsByMonthAPI = async (postData) => {
  
  const result= axios.get(USOBApiRequest.USOBApiBaseURL + `/page/analytics`, {
    headers: {
      "Content-Type": "text/plain",
      userid: getAuthUserDetails()?.usob_id,
      customerid: getAuthUserDetails()?.usob_cid,
      roleid: getAuthUserDetails()?.usob_rid,
    },
    params:postData,
   
  })
  
  return result;
};

function* submitAnalyticsByMonthSaga({ postData }) {
  try {
    yield put(analyticsByMonthLoading(true));
    const data = yield call(postAnalyticsByMonthAPI, postData);
    yield put(submitAnalyticsByMonthActionDispatcher(data));
    yield put(submitAnalyticsByMonthErrorDispatcher({}));
    yield put(analyticsByMonthLoading(false));
  } catch (e) {
    yield put(submitAnalyticsByMonthActionDispatcher({}));
    yield put(
      submitAnalyticsByMonthErrorDispatcher(e.response.data)
    );
    yield put(analyticsByMonthLoading(false));
  }
}

function* submitAnalyticsByMonthWatcher() {
  yield takeEvery(SUBMIT_ANALYTICS_BY_MONTH_ACTION_REQUESTED, submitAnalyticsByMonthSaga);
}
export default submitAnalyticsByMonthWatcher;
